export default __webpack_public_path__ + "static/media/223.0cfdb110.png";